import { CORNERSTONE_ARTICLES } from "./cornerstoneArticles";
import { getGuidePathForCountryId } from "./localization";

export const CORNERSTONE_ARTICLE_SUMMARIES = CORNERSTONE_ARTICLES.map((article) => ({
  title: article.title,
  slug: article.slug,
  category: article.category,
  excerpt: article.excerpt,
  coverImage: article.coverImage,
  metaDescription: article.metaDescription,
  scopeType: article.scopeType || "Global",
  countryId: article.countryId,
  primaryCalculatorId: article.primaryCalculatorId,
  relatedCalculatorIds: article.relatedCalculatorIds,
  route: getGuidePathForCountryId(article.slug, article.countryId, article.scopeType),
}));
